import { StoryblokComponent } from "@storyblok/react";
import { CustomSiteConfigModel } from "../Models/CustomSiteConfigModel";
import NotificationDisplay from "../Notification/Notification";
import { useEffect, useRef, useState } from "react";

const NotificationStripNav: React.FC<{
  customSiteConfig: CustomSiteConfigModel;
}> = ({ customSiteConfig }) => {
  const [smallHeader, setSmallHeader] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 900) {
        const currentScrollY = window.scrollY;

        if (Math.abs(currentScrollY - lastScrollY.current) > 100) {
          setSmallHeader(currentScrollY > 100);
          lastScrollY.current = currentScrollY;
        }
      } else {
        setSmallHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="notification-strip-nav">
      <NotificationDisplay />
      {!smallHeader &&
      customSiteConfig?.content?.NavigationStrip &&
      customSiteConfig?.content?.NavigationStrip?.length > 0
        ? customSiteConfig.content.NavigationStrip.map((blokk: any) => {
            if (!blokk.content) {
              return null;
            }
            return (
              <StoryblokComponent
                blok={blokk.content}
                key={blokk.content._uid}
              />
            );
          })
        : null}

      {customSiteConfig?.content?.nav &&
      customSiteConfig?.content?.nav?.length > 0
        ? customSiteConfig.content.nav.map((blokk: any) => (
            <StoryblokComponent
              blok={blokk}
              key={blokk._uid}
              smallHeader={smallHeader}
              footer={customSiteConfig?.content?.footer}
            />
          ))
        : null}
    </div>
  );
};

export default NotificationStripNav;
